"use strict";

function helper(Handlebars) {
  /**
   * Similar to {{#if}} block helper but accepts multiple arguments.
   *
   * @param  {[type]} context [description]
   * @return {String}         [description]
   *
   * @example: {{ifAll this compare=that}}
   */
  function ifAll() {
    var i = 0;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var content = Array.prototype.pop.call(args);
    var allTrue = true;
    while (i <= args.length - 1) {
      allTrue = allTrue && args[i];
      i += 1;
    }
    return allTrue ? content.fn(this) : content.inverse(this);
  }
  Handlebars.registerHelper('ifAll', ifAll);
  return ifAll;
}
module.exports = helper;
